module.exports = __webpack_public_path__ + "img/lpyb.15d0df78.png";